import React from "react";
import { TextField } from "@mui/material";

const TextFieldForObjectState = ({ formInfo, Object, handleChange }) => {
  const inputProps = {
    style: {
      backgroundColor: "white",
      textAlign: "left",
      color: "black", // Set the font color to black
    },
  };

  const inputLabelProps = {
    style: {
      fontSize: "1.2rem", // Increase the font size of the label
      color: "black", // Set the label color to black
    },
    shrink: true,
  };

  let label = Object.label;
  let name = Object.name;

  let AboveText = Object.AboveText;

  return (
    <>
      {window.innerWidth >= 800 ? (
        <div style={{ fontSize: "1.2rem", color: "black" }}>{AboveText}</div>
      ) : (
        <div style={{ fontSize: "1.2rem", color: "black" }}>
          {AboveText}
          <br></br>
          <i>{label}:</i>
        </div>
      )}
      <TextField
        label={window.innerWidth >= 800 ? label : ""}
        name={name}
        value={formInfo && formInfo[name] ? formInfo[name] : ""}
        onChange={handleChange}
        variant="outlined"
        fullWidth
        InputProps={inputProps}
        InputLabelProps={inputLabelProps}
      />
    </>
  );
};

export default TextFieldForObjectState;
